import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';
import { IOrdinalProps, ordinalColors } from './shared.styles';

export const Line = styled.g``;
export const LinePath = styled.path<IOrdinalProps>`
    fill: transparent;
    stroke: ${ordinalColors};
    stroke-width: 2px;
`;
export const LineDot = styled.circle<IOrdinalProps>`
    fill: ${Variables.Colors.white};
    stroke: ${ordinalColors};
    stroke-width: 2px;
`;
export const BarRect = styled.rect<IOrdinalProps>`
    fill: ${ordinalColors};
`;
